import BaseRequest from './index'
import { Transaction } from '../redux/types/transaction'

class TransactionService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.getTransactions = this.getTransactions.bind(this)
    this.getPageTransactions = this.getPageTransactions.bind(this)
    this.searchTransactions = this.searchTransactions.bind(this)
    this.filterTransactionsType = this.filterTransactionsType.bind(this)
    this.filterTransactionsService = this.filterTransactionsService.bind(this)
    this.filterTransactionsStatus = this.filterTransactionsStatus.bind(this)
  }

  async getTransactions(): Promise<Transaction[]> {
    return await this.api.get('/user/transactions')
  }
  async getPageTransactions(pageNumber: any): Promise<Transaction[]> {
    return await this.api.get(`/user/transactions?page=${pageNumber}`)
  }
  async searchTransactions(description: any): Promise<Transaction[]> {
    return await this.api.get(
      `/user/transactions?type&status&service&per_page&search=${description}`
    )
  }
  async filterTransactionsType(type: any): Promise<Transaction[]> {
    return await this.api.get(
      `/user/transactions?type=${type}&status&service&per_page&search`
    )
  }
  async filterTransactionsService(service: any): Promise<Transaction[]> {
    return await this.api.get(
      `/user/transactions?type&status&service=${service}&per_page&search}`
    )
  }
  async filterTransactionsStatus(status: any): Promise<Transaction[]> {
    return await this.api.get(
      `/user/transactions?type&status=${status}&service&per_page&search`
    )
  }
}
const transactionService = new TransactionService()

export default transactionService
